var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCorrelation = function SvgCorrelation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#correlation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 24v25.6c0 2.24 0 3.36.436 4.216a4 4 0 0 0 1.748 1.748C22.04 56 23.16 56 25.4 56H51"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#correlation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M59 48V22.4c0-2.24 0-3.36-.436-4.216a4 4 0 0 0-1.748-1.748C55.96 16 54.84 16 52.6 16H27"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.188,
    height: 45.188,
    x: 0.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#correlation_svg__c)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#correlation_svg__d)",
    shapeRendering: "crispEdges"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#correlation_svg__e)",
    fillOpacity: 0.5,
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C35 11.04 35 12.16 35 14.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C31.96 32 30.84 32 28.6 32H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 28.96 11 27.84 11 25.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#correlation_svg__f)",
    fillOpacity: 0.25,
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C35 11.04 35 12.16 35 14.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C31.96 32 30.84 32 28.6 32H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 28.96 11 27.84 11 25.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M17.4 8.5h11.2c1.128 0 1.945 0 2.586.053.637.052 1.057.153 1.403.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v11.2c0 1.128 0 1.945-.053 2.586-.052.637-.153 1.057-.329 1.403a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.402.328-.641.053-1.458.053-2.586.053H17.4c-1.128 0-1.945 0-2.586-.053-.637-.052-1.057-.153-1.403-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.402-.053-.641-.053-1.458-.053-2.586V14.4c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.642-.053 1.459-.053 2.587-.053Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 45.188,
    height: 45.188,
    x: 32.406,
    y: 32.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#correlation_svg__g)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#correlation_svg__h)",
    shapeRendering: "crispEdges"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#correlation_svg__i)",
    fillOpacity: 0.2,
    d: "M43 46.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C46.04 40 47.16 40 49.4 40h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 43.04 67 44.16 67 46.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 64 62.84 64 60.6 64H49.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C43 60.96 43 59.84 43 57.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#correlation_svg__j)",
    d: "M43 46.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C46.04 40 47.16 40 49.4 40h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 43.04 67 44.16 67 46.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 64 62.84 64 60.6 64H49.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C43 60.96 43 59.84 43 57.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M49.4 40.5h11.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v11.2c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.056-.329 1.402a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H49.4c-1.128 0-1.945 0-2.587-.053-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.401-.053-.642-.053-1.459-.053-2.587V46.4c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.642-.053 1.459-.053 2.587-.053Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "correlation_svg__a",
    width: 36,
    height: 36,
    x: 17,
    y: 23,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_3603",
    result: "effect2_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_3603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "correlation_svg__b",
    width: 36,
    height: 36,
    x: 25,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_3603",
    result: "effect2_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_3603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "correlation_svg__d",
    width: 45.188,
    height: 45.188,
    x: 0.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_3603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "correlation_svg__h",
    width: 45.188,
    height: 45.188,
    x: 32.406,
    y: 32.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_3603"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_3603",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "correlation_svg__e",
    x1: 23,
    x2: 23,
    y1: 18.65,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "correlation_svg__i",
    x1: 55,
    x2: 55,
    y1: 50.65,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "correlation_svg__c",
    transform: "translate(-.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 14.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C14.04 8 15.16 8 17.4 8h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C35 11.04 35 12.16 35 14.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C31.96 32 30.84 32 28.6 32H17.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C11 28.96 11 27.84 11 25.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "correlation_svg__g",
    transform: "translate(-32.406 -32.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 46.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C46.04 40 47.16 40 49.4 40h11.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C67 43.04 67 44.16 67 46.4v11.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C63.96 64 62.84 64 60.6 64H49.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C43 60.96 43 59.84 43 57.6z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "correlation_svg__f",
    width: 2.667,
    height: 2.667,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#correlation_svg__k",
    transform: "scale(.0026)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "correlation_svg__j",
    width: 2.667,
    height: 2.667,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#correlation_svg__k",
    transform: "scale(.0026)"
  })))));
};
export default SvgCorrelation;